module.exports = __webpack_public_path__ + "img/img1.7fa5afac.svg";